import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryProvider } from '@/providers/QueryProvider'
import { AuthProvider } from '@/providers/AuthProvider'
import { AuthGuard } from '@/components/layout/AuthGuard'
import { AppShell } from '@/components/layout/AppShell'
import { UserListPage } from '@/pages/UserListPage'
import { UserDetailPage } from '@/pages/UserDetailPage'
import { ExerciseOverviewPage } from '@/pages/ExerciseOverviewPage'
import { AnalyticsOverviewPage } from '@/pages/AnalyticsOverviewPage'
import { RevenuePage } from '@/pages/RevenuePage'
import { EmailSeriesPage } from '@/pages/EmailSeriesPage'
import { RetentionPage } from '@/pages/RetentionPage'
import { ReferralOverviewPage } from '@/pages/referrals/ReferralOverviewPage'
import { CampaignListPage } from '@/pages/referrals/CampaignListPage'
import { CampaignCreatePage } from '@/pages/referrals/CampaignCreatePage'
import { CampaignDetailPage } from '@/pages/referrals/CampaignDetailPage'
import { ReferralListPage } from '@/pages/referrals/ReferralListPage'
import { PayoutsPage } from '@/pages/referrals/PayoutsPage'
import { ManualAttributionPage } from '@/pages/referrals/ManualAttributionPage'
import { NewsletterListPage } from '@/pages/newsletter/NewsletterListPage'
import { NewsletterBuilderPage } from '@/pages/newsletter/NewsletterBuilderPage'
import { NewsletterDetailPage } from '@/pages/newsletter/NewsletterDetailPage'
import { NotFound } from '@/pages/NotFound'

export default function App() {
  return (
    <BrowserRouter>
      <QueryProvider>
        <AuthProvider>
          <Routes>
            <Route element={<AuthGuard />}>
              <Route element={<AppShell />}>
                <Route index element={<Navigate to="/users" replace />} />
                <Route path="/users" element={<UserListPage />} />
                <Route path="/users/:userId" element={<UserDetailPage />} />
                <Route path="/exercises" element={<ExerciseOverviewPage />} />
                <Route path="/analytics" element={<AnalyticsOverviewPage />} />
                <Route path="/analytics/revenue" element={<RevenuePage />} />
                <Route path="/analytics/email" element={<EmailSeriesPage />} />
                <Route path="/analytics/retention" element={<RetentionPage />} />
                <Route path="/referrals" element={<ReferralOverviewPage />} />
                <Route path="/referrals/campaigns" element={<CampaignListPage />} />
                <Route path="/referrals/campaigns/new" element={<CampaignCreatePage />} />
                <Route path="/referrals/campaigns/:campaignId" element={<CampaignDetailPage />} />
                <Route path="/referrals/list" element={<ReferralListPage />} />
                <Route path="/referrals/payouts" element={<PayoutsPage />} />
                <Route path="/referrals/attribute" element={<ManualAttributionPage />} />
                <Route path="/newsletters" element={<NewsletterListPage />} />
                <Route path="/newsletters/new" element={<NewsletterBuilderPage />} />
                <Route path="/newsletters/:newsletterId/edit" element={<NewsletterBuilderPage />} />
                <Route path="/newsletters/:newsletterId" element={<NewsletterDetailPage />} />
              </Route>
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </QueryProvider>
    </BrowserRouter>
  )
}
